<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <div class="text1">
          “매일 늘리는 것이 아니라 매일 줄이는 것이다. 불필요한 것들은 잘라
          버려라"<br />
          <br />
          불필요한 것들은 우리를 불행하게 만들고 고객을 불행하게 만듭니다 <br />
          먼데이리스는 핵심 가치에 집중합니다.<br />
          이로 인한 부가가치는 고객, 회사, 구성원 모두에게 공유됩니다<br />
          고객의 성공이 먼데이리스의 성공이 되고 모두가 행복해집니다<br />
          이를 위해 먼데이리스는 항상 더 나은 방법을 연구합니다<br />
          <br />
          어제보다 항상 나아지는 먼데이리스
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
export default {
  components: {
    Caption,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 30px;
  z-index: 1;
  /* background-color: #f00; */
}

.text1 {
  font-size: 20px;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 30px;
    z-index: 1;
    /* background-color: #f00; */
  }

  .text1 {
    font-size: 16px;
  }
}
</style>
  